<template>
  <v-list subheader two-line class="pa-0">
    <v-subheader>My Children</v-subheader>
    <PersonListItemWithAvatarMinusParentDetails
      v-for="(child, index) in children"
      :personId="child.personId"
      :key="index"
      :child="child"
      :parent="parent"
    />
  </v-list>
</template>

<script>
import ChildListItem from './ChildListItem';
import PersonListItemWithAvatarMinusParentDetails from './../Global/People/PersonListItemWithAvatarMinusParentDetails.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      showParentTwice: false,
      usedInCardManagement: true
    };
  },

  computed: {
    ...mapGetters(['parent']),

    children() {
      return this.$store.getters.children;
    }
  },

  components: {
    ChildListItem,
    PersonListItemWithAvatarMinusParentDetails
  },
  mounted() {}
};
</script>

<style lang="css"></style>
